import { Bugsnag, isBugsnagStarted } from './bugsnagConfig';

export const leaveBreadcrumb = (name: string, metadata?: Record<string, any>) => {
  if (!isBugsnagStarted()) return;
  try {
    Bugsnag.leaveBreadcrumb(name, metadata);
  } catch {
    // ignore breadcrumb errors
  }
};

export const addMetadata = (section: string, metadata: Record<string, any>) => {
  if (!isBugsnagStarted()) return;
  try {
    Bugsnag.addMetadata(section, metadata);
  } catch {
    // ignore metadata errors
  }
};

export const notifyError = (error: Error | string, metadata?: Record<string, any>) => {
  if (!isBugsnagStarted()) return;
  try {
    const err = error instanceof Error ? error : new Error(error);
    Bugsnag.notify(err, (event) => {
      if (metadata) {
        Object.entries(metadata).forEach(([section, value]) => {
          event.addMetadata(section, value as any);
        });
      }
    });
  } catch {
    // ignore notify errors
  }
};

export const setUser = (id: string | null | undefined, email?: string | null) => {
  if (!isBugsnagStarted() || !id) return;
  try {
    Bugsnag.setUser(id, email || undefined);
  } catch {
    // ignore setUser errors
  }
};
